/* SecureNu v1.18: kleine UX-verbeteringen uit de mysteryshopper-check. */
(function () {
  'use strict';

  /* 1. Melding na "In winkelwagen" goed zichtbaar, ook op mobiel boven de WhatsApp-knop. */
  var css = document.createElement('style');
  css.textContent =
    '.toast{z-index:10000!important;left:50%!important;right:auto!important;transform:translateX(-50%);' +
    'max-width:calc(100% - 32px);box-shadow:0 10px 30px rgba(0,0,0,.25)}' +
    '@media (max-width:749px){.toast{top:12px!important;bottom:auto!important;width:calc(100% - 32px)}}' +
    '.btn.is-added,[data-add-button].is-added{background:#16a34a!important;border-color:#16a34a!important;color:#fff!important}';
  document.head.appendChild(css);

  function markAdded() {
    document.querySelectorAll('[data-add-button]').forEach(function (button) {
      if (button.dataset.addedTimer) return;
      var original = button.textContent;
      button.classList.add('is-added');
      button.textContent = '✓ Toegevoegd';
      button.dataset.addedTimer = '1';
      setTimeout(function () {
        button.classList.remove('is-added');
        button.textContent = original;
        delete button.dataset.addedTimer;
      }, 2500);
    });
  }

  function wrapToast() {
    if (!window.theme || typeof window.theme.toast !== 'function' || window.theme.toast._wrapped) return;
    var original = window.theme.toast;
    var wrapped = function (message, link) {
      original(message, link);
      if (window.theme.strings && message === window.theme.strings.added) markAdded();
    };
    wrapped._wrapped = true;
    window.theme.toast = wrapped;
  }

  /* 2. Filterlabel "Price" in het Nederlands. */
  function translateFilters() {
    document.querySelectorAll('.filters__group legend').forEach(function (legend) {
      if (legend.textContent.trim() === 'Price') legend.textContent = 'Prijs';
    });
  }

  function init() {
    wrapToast();
    translateFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
